import React from 'react'
import { connect } from 'react-redux'

const TextInput = (props) => {
    const {
        input,
        label,
        placeHolder,
        require,
        halfRow = false,
        disabled = false,
        maxLength = 100,
        meta: { touched, error },
        showError  = false,
        type = 'text',
        borderCustom= false,
        pxNone = false,
        customStyle = false,
        textCenter = false
    } = props

    return (
        <div className={`${halfRow ? 'w-1/2' : 'w-full'} ${pxNone ? "" : "px-3" }  ${customStyle ? customStyle: "" }`}>
            <label className="block  tracking-wide text-gray-800 font-bold text-sm  mb-2 text-left" >
                {label}
                {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
                {touched && error ? <span className='ml-2 text-red-500 require'>{error}</span> : null}
                {showError ? <span className='ml-2 text-red-500 require'>{showError}</span> : null}
            </label>
            <input
                style={{ backgroundColor: disabled ? "#3b3b3b0a" : touched && error ? "#FFF0F0" : "" , opacity:1, lineHeight:'1.2'}}
                {...input}
                className={` ${textCenter ? 'text-center':""} text-base appearance-none outline-none focus:outline-none  block w-full 0 text-gray-800 border ${borderCustom ? borderCustom : 'border-[#FBC558]'} rounded py-3 px-4  leading-tight `}
                id="grid-first-name"
                type={type}
                disabled={disabled}
                placeholder={placeHolder}
                maxLength={maxLength}
            />
        </div>
    )
}

const mapStateToProps = (state) => {

    return {

    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(TextInput)